import React, { useState } from "react";
import { FaShoppingCart, FaHeart, FaStar, FaTh, FaShieldAlt } from "react-icons/fa";
import { myCustomTheme } from "../../Theme";
import "./style/ProductGrid.css";

const ProductGrid = ({
    products,
    isLoading,
    sliderIndex,
    onProductClick,
    onAddToCart,
    onAddToWishlist,
    categories
}) => {
    const [activeCategory, setActiveCategory] = useState("all");

    const filteredProducts = activeCategory === "all"
        ? products
        : products.filter(p => p.categoryId === activeCategory);

    const pillBase = {
        padding: "8px 18px",
        borderRadius: "50px",
        border: "none",
        cursor: "pointer",
        fontSize: "13px",
        fontWeight: "600",
        transition: "all 0.2s"
    };

    const activePill = {
        ...pillBase,
        backgroundColor: myCustomTheme.colors.button_bg,
        color: myCustomTheme.colors.button_text
    };

    const inactivePill = {
        ...pillBase,
        backgroundColor: myCustomTheme.colors.high_light,
        color: myCustomTheme.colors.heading
    };

    if (isLoading) {
        return (
            <div className="product-grid">
                <div className="products-loader">
                    <div className="loader-ring"></div>
                </div>
            </div>
        );
    }

    return (
        <div>
            {categories && categories.length > 0 && (
                <div style={{
                    display: "flex",
                    gap: "10px",
                    flexWrap: "wrap",
                    marginBottom: "24px",
                    padding: "4px 0"
                }}>
                    <button
                        style={activeCategory === "all" ? activePill : inactivePill}
                        onClick={() => setActiveCategory("all")}
                    >
                        <FaTh style={{ marginRight: "6px", verticalAlign: "middle" }} />
                        All
                    </button>
                    {categories.map(cat => (
                        <button
                            key={cat.id}
                            style={activeCategory === cat.id ? activePill : inactivePill}
                            onClick={() => setActiveCategory(cat.id)}
                        >
                            {cat.name}
                        </button>
                    ))}
                </div>
            )}

            {filteredProducts.length === 0 ? (
                <div className="product-grid">
                    <p style={{
                        gridColumn: "1/-1", textAlign: "center",
                        color: myCustomTheme.colors.menu_text, padding: "40px 20px"
                    }}>
                        No products found in this category.
                    </p>
                </div>
            ) : (
                <div className="product-grid">
                    {filteredProducts.map((product) => {
                        const imagesArr = product.images || [];
                        const currentTargetImageIndex = imagesArr.length > 1 ? sliderIndex % imagesArr.length : 0;

                        return (
                            <div
                                className="product-card"
                                key={product.id}
                                onClick={() => onProductClick(product)}
                                style={{
                                    backgroundColor: "#fff",
                                    boxShadow: myCustomTheme.shadows.soft,
                                    borderRadius: "24px",
                                    border: `1px solid ${myCustomTheme.colors.high_light}`
                                }}
                            >
                                <div className="slider-box" style={{ backgroundColor: myCustomTheme.colors.bg_secondary }}>
                                    <span
                                        className="type-badge-indicator"
                                        style={{
                                            backgroundColor: myCustomTheme.colors.button_bg,
                                            color: myCustomTheme.colors.button_text
                                        }}
                                    >
                                        {product.type}
                                    </span>
                                    <img
                                        key={currentTargetImageIndex}
                                        src={imagesArr[currentTargetImageIndex] || "https://images.unsplash.com/photo-1531403009284-440f080d1e12"}
                                        alt={product.name}
                                        className="slider-image"
                                        style={{ animation: "smoothFadeEffect 0.5s cubic-bezier(0.4, 0, 0.2, 2)" }}
                                    />
                                </div>

                                <div className="product-content">
                                    <h2 style={{ color: myCustomTheme.colors.heading, fontFamily: myCustomTheme.typography.heading_font }}>
                                        {product.name}
                                    </h2>

                                    <p
                                        className="rating"
                                        style={{
                                            backgroundColor: myCustomTheme.colors.high_light,
                                            color: myCustomTheme.colors.heading
                                        }}
                                    >
                                        <FaStar
                                            className="star-filled"
                                            style={{ marginRight: "4px", display: "inline-block", verticalAlign: "middle", color: "#f59e0b" }}
                                        />
                                        <span style={{ verticalAlign: "middle" }}>{product.rating}</span>
                                    </p>

                                    <div className="price-box">
                                        <span className="mrp" style={{ color: myCustomTheme.colors.menu_text }}>
                                            Rs.{product.type === "Customize"
                                                ? Math.round(product.mrp * 6 * 1.18)
                                                : Math.round(product.mrp * 1.18)}
                                        </span>
                                        <span className="sp" style={{ color: myCustomTheme.colors.heading }}>
                                            Rs.{product.type === "Customize"
                                                ? Math.round(product.sellingPrice * 6 * 1.18)
                                                : Math.round(product.sellingPrice * 1.18)}
                                        </span>
                                        <span
                                            className="discount"
                                            style={{
                                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                                color: myCustomTheme.colors.heading
                                            }}
                                        >
                                            {product.discount}% OFF
                                        </span>
                                    </div>

                                    {/* GST included note */}
                                    <p style={{
                                        fontSize: "10px",
                                        color: "#15803d",
                                        fontWeight: "600",
                                        marginTop: "4px",
                                        display: "flex",
                                        alignItems: "center",
                                        gap: "4px"
                                    }}>
                                        <FaShieldAlt style={{ fontSize: "9px", color: "#16a34a", flexShrink: 0 }} />
                                        18% GST incl. in MRP &amp; discount price
                                    </p>

                                    <p className="details" style={{ color: myCustomTheme.colors.menu_text }}>
                                        {product.description}
                                    </p>

                                    <div className="icon-buttons" style={{ borderTop: `1px solid ${myCustomTheme.colors.high_light}` }}>
                                        <button
                                            className="icon-btn"
                                            onClick={(e) => { e.stopPropagation(); onAddToCart(product, e); }}
                                            style={{
                                                backgroundColor: myCustomTheme.colors.button_bg,
                                                color: myCustomTheme.colors.button_text
                                            }}
                                        >
                                            <FaShoppingCart />
                                        </button>
                                        <button
                                            className="icon-btn heart-btn"
                                            onClick={(e) => { e.stopPropagation(); onAddToWishlist(product, e); }}
                                            style={{
                                                backgroundColor: myCustomTheme.colors.bg_secondary,
                                                color: myCustomTheme.colors.heading
                                            }}
                                        >
                                            <FaHeart />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default ProductGrid;